import { translate } from '@/domains/core/localization/translate';
export const {
  avisqualiTranslation,
  incentivizedTranslation
} = translate({
  "avisqualiTranslation": "Tester review",
  "incentivizedTranslation": "[This review was submitted in response to an offer]"
});